/**
 * Portal surface tokens — design_handoff_auth_profile_planner (Sept 27 2026), §Design Tokens.
 * Shared by the auth screens, the Portal Profile, the Planner and Event Published. Numbers live
 * here so a component never retunes them.
 */
export const RING = 'linear-gradient(90deg,#FD199F,#FF33C6,#B5B1FF,#127BFD,#22ECFB,#FAE1B4,#FCAA6D,#FD199F)';
export const RING_STOPS = ['#FD199F', '#FF33C6', '#B5B1FF', '#127BFD', '#22ECFB', '#FAE1B4', '#FCAA6D', '#FD199F'];

export const C = {
  black: '#000000', cardDark: '#111111', surfaceDark: '#161616', surfaceDarkHover: '#262626', edgeDark: '#2A2A2A',
  hairDark: '#1F1F1F', ruleDark: '#222222',
  inside: '#F5F5F5', white: '#FFFFFF', field: '#F2F2F2', waiting: '#FAFAFA', skeleton: '#EDEDED',
  gray400: '#9CA3AF', gray500: '#6B7280', gray600: '#4B5563',
  onBlack2: '#8A8A8A', onBlack3: '#BDBDBD', onBlack4: '#6B6B6B',
  pink: '#FF00AA', pinkLight: '#FF66C4', pastelPink: '#FFCCE6', errorBg: '#2A0B1C', errorEdge: '#5A1A3E', selectedRow: '#FFE8F4',
  cyan: '#22ECFB', green: '#22C55E', greenBg: '#DCFCE7', greenFg: '#15803D', held: '#FAE1B4',
};

export const PASTEL_WALL = 'linear-gradient(100deg,#F4EFF8 0%,#F5D3F1 32%,#F6F0FA 58%,#DCE3F8 82%,#B9DEF6 100%)';

/** `border: Npx solid transparent` + this background = the ring as a border around `fill`. */
export const ringBorder = (fill) => `linear-gradient(${fill},${fill}) padding-box, ${RING} border-box`;

export const EASE_OUT = 'cubic-bezier(0,0,.2,1)';
export const EASE_DRAW = 'cubic-bezier(.6,0,.2,1)';

/** System label: ALL CAPS JetBrains Mono, letter-spaced. */
export const label = (size, tracking = '.14em', weight = 700) => ({ fontSize: size, fontWeight: weight, letterSpacing: tracking, textTransform: 'uppercase' });
